import TabPaneFilter from '../tabpanefilter';
import Typography from 'helpers/fonts';
import React, { useState } from 'react';
import { useAppState } from 'state/appstate/appstate';
import shallow from 'zustand/shallow';
import { Option, OptionFolder } from 'api';
import { uniqueArray } from 'helpers/util';
import TabPaneCards from './tabpane-features-cards';
import { useViewerState } from 'state/viewer-state/viewer-state';
import {
  getInstancesForGhModelType,
  GhModelType,
  OptionInstance,
} from '@swd_admin/cdc-viewer';

export interface FeatureInstance extends Option {
  instanceId?: string;
}

export interface TabPaneFeaturesProps {
  option: Option;
  optionInstance: OptionInstance;
  featuresType: string;
}

const filterDoorFeatures = (feature: Option, option: Option) => {
  const knobs = ['DH1A', 'DH3A'];
  const pulls = ['RP2BP', 'RU6BI'];
  const ghModelJson = option.ghModelJson && JSON.parse(option.ghModelJson);
  const externalFeatures = ghModelJson?.externalFeatures;
  const isPull = pulls.includes(feature.orderCode)
    && externalFeatures?.some(({ id }: { id: string }) => pulls.includes(id));
  const isKnob = knobs.includes(feature.orderCode)
    && externalFeatures?.some(({ id }: { id: string }) => knobs.includes(id));
  return isPull || isKnob;
}

export const TabPaneFeatures: React.FunctionComponent<TabPaneFeaturesProps> = ({
  optionInstance,
  featuresType,
  option,
}) => {
  const viewerState = useViewerState.getState().viewerState;

  const appState = useAppState(
    (state) => ({
      features: state.styleProduct.style?.features,
      featureFolders: state.styleProduct.style?.featureFolders,
      shapeDiverIdToDbId: state.dicts.shapeDiverIdToDbId,
    }),
    shallow
  );

  const instances = getInstancesForGhModelType(
    viewerState!.internal.ghModels,
    viewerState!.style.instances,
    GhModelType.Features
  );

  const allFeatures = appState.features
    ?.filter((f) => f.optionTypeId === featuresType &&
      (featuresType !== 'door_features' || filterDoorFeatures(f, option))
    )
    ?.map((f): FeatureInstance => {
      const featureInstance = instances?.find(
        (i) => i.parentId === optionInstance.id && i.optionId === f.orderCode
      );
      return { ...f, instanceId: featureInstance?.id };
    });

  const filters: OptionFolder[] = uniqueArray(
    allFeatures!.map((f) => f.optionFolderId)
  )
    .map(
      (id) =>
        appState.featureFolders?.find(
          (folder) => folder.id === id
        ) as OptionFolder
    )
    .filter((folder) => !!folder);
  const [selectedFilter, setSelectedFilter] = useState<OptionFolder>();

  return (
    <>
      {filters && filters.length > 1 && (
        <TabPaneFilter
          filters={filters}
          selectFilter={(filter) => {
            setSelectedFilter(filter);
          }}
          selectedFilter={selectedFilter}
        />
      )}

      {selectedFilter?.description && (
        <div style={{ marginTop: '16px' }}>
          <Typography styleid={9}>{selectedFilter?.description}</Typography>
        </div>
      )}

      <TabPaneCards
        optionInstance={optionInstance}
        features={
          selectedFilter
            ? allFeatures!.filter(
                (f) => selectedFilter?.id === f.optionFolderId
              )
            : allFeatures!
        }
      />
    </>
  );
};
